import { ObjectDb } from './object.db';
import { ServiceGridItemObject } from '@it2go/types';
import { Injectable } from '@angular/core';
import { addressInfoFrag } from '../../utils/type/address.common-type';

@Injectable({ providedIn: 'root' })
export class ServiceDb extends ObjectDb<ServiceGridItemObject> {

    public tableName = 'service';

    protected override columnMap = {};
    protected override indices = ['id', 'organizationId'];
    protected override checkField = null;

    protected gqlMethod = 'getServices';

    protected syncFragment = `
        id
        name
        type
        serviceTypeId
        color
        organizationId
        address {
            ${addressInfoFrag}
        }
        expertise {
            code
            name
        }
        form
        sharePersons
        timeRanges {
            order
            active
            from
            to
        }
        workplaces {
            id
            name
            dateFrom
            dateTo
            address {
                ${addressInfoFrag}
            }
        }
        serviceSettings {
            id
            key
            data
            serviceId
        }
        operationalCapacity {
            name
            amount
            dateFrom
            dateTo
        }
    `;

}
